import { AdaptAiBannerLocation, AdaptAiBannerVariant } from '../../../constants/ab-tests/adapt-ai-banner';
import qualityEventsHelpers from '../quality-events.helpers';
import {
    MATERIAL_CARD_ADAPT_CTA_ENTRY_POINT,
    MaterialCardAiButtonDestination
} from './my-materials-page-quality-events.constants';

// One id per card click. The cohort's click leaves the page right after, often before the QE response, so the copy
// trackAndForget keeps of the event is sent again on the next eduki page load: for a teacher without a Studio token,
// the login bridge Studio sends them to seconds later. Both rows carry this id, so Analytics can count the click once
const newClickId = (): string =>
    window.crypto?.randomUUID?.() ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export const MY_MATERIALS_PAGE_EVENTS = {
    createInteractive() {
        qualityEventsHelpers.track({
            type: 'createNewInteractive'
        });
    },
    createFolderBtn() {
        qualityEventsHelpers.track({
            type: 'create-folder-btn-click'
        });
    },
    folderCreateUpdate(isEdit: boolean) {
        qualityEventsHelpers.track({
            type: isEdit ? 'folder-updated' : 'folder-created'
        });
    },
    archiveMaterials(isMultiSelect: boolean, item: Material, materialIds: number[]) {
        isMultiSelect
            ? qualityEventsHelpers
                  .track({
                      type: 'multiArchiveMaterials',
                      extra: JSON.stringify({ materials: materialIds.length, materialIds })
                  })
                  .finally(() => window.location.reload())
            : qualityEventsHelpers
                  .track({
                      type: 'archiveMaterial',
                      item_id: item.id,
                      item_price: item.finalPrice
                  })
                  .finally(() => window.location.reload());
    },
    removeFolder() {
        qualityEventsHelpers.track({
            type: 'removeFolder'
        });
    },
    unarchiveMaterial(item: Material) {
        qualityEventsHelpers
            .track({
                type: 'unarchiveMaterial',
                item_id: item.id,
                item_price: item.finalPrice
            })
            .finally(() => window.location.reload());
    },
    multiUpdateMaterialsFolders(selectedFolders: number[], materialIds: number[]) {
        qualityEventsHelpers.track({
            type: 'multiUpdateMaterialsFolders',
            extra: JSON.stringify({ folders: selectedFolders.length, materials: materialIds.length })
        });
    },
    updateMaterialFolders(selectedFolders: number[]) {
        qualityEventsHelpers.track({
            type: 'updateMaterialFolders',
            extra: JSON.stringify({ folders: selectedFolders.length })
        });
    },
    materialCardRatingCta(rating: number) {
        qualityEventsHelpers.track({
            type: 'material-card-rating-cta',
            extra: JSON.stringify(rating)
        });
    },
    materialCardReviewStar(isReviewed?: boolean) {
        return qualityEventsHelpers.track({
            type: 'material-card-review-star',
            extra: JSON.stringify({ isReviewed })
        });
    },
    adaptAiBannerClosed(variant: AdaptAiBannerVariant, location: AdaptAiBannerLocation) {
        qualityEventsHelpers.track({
            type: 'adapt-ai-banner-closed',
            extra: variant,
            source: location
        });
    },
    adaptAiBannerLinkClick(variant: AdaptAiBannerVariant, location: AdaptAiBannerLocation) {
        qualityEventsHelpers.track({
            type: 'adapt-ai-banner-link-click',
            extra: variant,
            source: location
        });
    },
    // The launch CTAs' click_adapt_cta (AI-1771), sent by the card AI button (AI-1806). trackAndForget, unlike theirs:
    // the cohort's click leaves for eduki Adapt in this tab right after, which would cancel a track request
    materialCardAiButtonClick(destination: MaterialCardAiButtonDestination) {
        qualityEventsHelpers.trackAndForget({
            type: 'click_adapt_cta',
            internal_path: MATERIAL_CARD_ADAPT_CTA_ENTRY_POINT,
            extra: JSON.stringify({
                entry_point: MATERIAL_CARD_ADAPT_CTA_ENTRY_POINT,
                destination,
                click_id: newClickId()
            })
        });
    }
};
